import { Event, GetEventQueryVariables } from '@akin-home/amplify';
import { createMockFunctions } from '@akin-home/testing';

const { listAsync, set, get } = createMockFunctions<
  Event,
  GetEventQueryVariables
>({
  key: 'events',
  find:
    ({ id }: { id?: string }) =>
    (event) =>
      event.id === id,
});

export {
  listAsync as listMockEventsAsync,
  set as setMockEvents,
  get as getMockEvent,
};
